import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFlow } from "../../context/FlowContext";
import { useSettings } from "../../context/SettingsContext";
import { useI18N } from "../../context/I18NContext";
import useDataStore from '../../store/useDataStore';
import useWidgetStore from '../../store/useWidgetStore';
import { useNavigate } from "react-router-dom";
import ConfigHolder from '../../config/ConfigHolder';
import { isMobile } from '../../../../helpers/browser';
import { normalizeSlug } from '../../../../helpers/admin';
import Purchase from '../actions/Purchase';
import Detail from '../actions/Detail';
import ImageBackground from '../ImageBackground';
export default function ObjectPicker(props) {
    var _a, _b, _c, _d, _e;
    const smartResize = true;
    const flow = useFlow();
    const theme = useTheme();
    const { t, ts } = useI18N();
    const [maxItems, setMaxitems] = useState();
    const [currentRoute, setCurrentRoute] = useState();
    const [addedProduct, setAddedProduct] = useState(false);
    const [addedProductName, setAddedProductName] = useState("Product");
    const { widgetMode, orientation, hasGroupedShop } = useSettings();
    const { cart, setCart } = useWidgetStore();
    const { products, setProducts, getProduct } = useDataStore();
    const isDesktop = window.screen.width > 500;
    const navigate = useNavigate();
    useEffect(() => {
        var _a, _b;
        let _optimalWidth = 300, _widgetWidth = ((_b = (_a = document.getElementById('_oa_widget_root')) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : window.screen.width) - 64, // 2x16 padding around the inner container per side
        _maxItems = orientation === "horizontal" && isDesktop ? Math.floor(_widgetWidth / _optimalWidth) : 1;
        let _currentRoute = location.hash.substring(12);
        if (_currentRoute.includes('/'))
            _currentRoute = _currentRoute.substring(0, _currentRoute.indexOf('/'));
        setMaxitems(_maxItems);
        setCurrentRoute(_currentRoute);
    }, []);
    const handleClick = (e) => {
        var _a, _b, _c;
        let button = e.target.closest('button');
        if (!button) {
            button = e.target.closest('.oa-product-container');
        }
        if (button) {
            let productId = parseInt(button.getAttribute('itemprop')), product = props.data.find((item) => item.id === productId);
            if (product) {
                if ((_a = props.config) === null || _a === void 0 ? void 0 : _a.toDetail) {
                    navigate(`/oa_widget_detail/${product.id}/${normalizeSlug(product.name)}`);
                }
                if ((_b = props.config) === null || _b === void 0 ? void 0 : _b.toCategory) {
                    navigate(`/oa_widget_category/${product.id}/${normalizeSlug(product.name)}`);
                }
            }
        }
        if ((_c = props.config) === null || _c === void 0 ? void 0 : _c.toNext) {
            // @ts-ignore
            flow === null || flow === void 0 ? void 0 : flow.onNext();
        }
    };
    const selectCallback = useCallback((productId, amount) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (products) {
            let product = getProduct(productId);
            if (product) {
                let _lines = cart.lines;
                // remove any previous required product selection from the apptype, as we only allow 1
                if (((_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.route.route) === "requiredProducts") {
                    _lines = _lines.filter((line) => line.origin !== "requiredPurchase");
                }
                let _lineItem = _lines.find((line) => line.productId === productId);
                if (_lineItem) {
                    _lineItem.quantity += amount;
                }
                else {
                    _lineItem = {
                        name: product.isVariation && product.variation
                            ? product.variation.name
                            : product.name,
                        price: product.isVariation && product.variation
                            ? product.variation.price
                            : product.price,
                        quantity: amount,
                        productId: productId,
                        productType: "product",
                        origin: (_c = (_b = props.config) === null || _b === void 0 ? void 0 : _b.action) !== null && _c !== void 0 ? _c : "optionalPurchase"
                    };
                    // add our new selection
                    _lines.push(_lineItem);
                }
                if (product.trackStock) {
                    let _products = products.map((_product) => {
                        if (_product.id === productId && _product.trackStock) {
                            _product.stock = _product.stock - amount;
                        }
                        return _product;
                    });
                    setProducts(_products);
                }
                // remove any previous required products by the product we're adding
                _lines = _lines.filter((line) => line.requiredBy !== productId);
                // add any required extra products
                if ((_d = product.crossselling) === null || _d === void 0 ? void 0 : _d.requires) {
                    (_e = product.crossselling) === null || _e === void 0 ? void 0 : _e.requires.forEach((requiredProductId) => {
                        let requiredProduct = products.find((_product) => {
                            if (_product.id === requiredProductId)
                                return _product;
                            return false;
                        });
                        if (requiredProduct) {
                            let _lineItem = {
                                name: requiredProduct.name,
                                price: requiredProduct.price,
                                quantity: 1,
                                productId: requiredProductId,
                                productType: "product",
                                origin: "requiredPurchase",
                                requiredBy: productId
                            };
                            _lines.push(_lineItem);
                        }
                    });
                }
                if (((_f = props.config) === null || _f === void 0 ? void 0 : _f.selectCallback) && props.config.isGrouped) {
                    (_g = props.config) === null || _g === void 0 ? void 0 : _g.selectCallback(_lineItem.name);
                }
                else {
                    setAddedProductName(_lineItem.name);
                    setAddedProduct(true);
                }
                setCart(Object.assign(Object.assign({}, cart), { lines: _lines }));
            }
        }
    }, [cart.lines, products]);
    const toNext = () => {
        if (orientation === "horizontal") {
            if (flow.onNext) {
                flow.onNext();
            }
        }
    };
    const toShop = () => {
        if (orientation === "horizontal") {
            setAddedProduct(false);
        }
        else {
            if (flow.onPrevious) {
                flow.onPrevious();
            }
        }
    };
    useEffect(() => {
        if (addedProduct) {
            setTimeout(() => {
                if (addedProduct) {
                    setAddedProduct(false);
                }
            }, 10000);
        }
    }, [addedProduct]);
    const parseImages = () => {
        let cards = document.querySelectorAll('.oa-product-container'), maxHeight = 0, imagesLoaded = true;
        if (cards.length === 0) {
            imagesLoaded = false;
        }
        cards.forEach((card) => {
            let cardImage = card.querySelector('img');
            if (!(cardImage === null || cardImage === void 0 ? void 0 : cardImage.complete) || !cardImage.complete)
                imagesLoaded = false;
            if (cardImage && cardImage.complete) {
                // @ts-ignore card = HTMLDivElement, not Element
                maxHeight = card.offsetWidth * 1.2;
            }
        });
        if (imagesLoaded) {
            cards.forEach((card) => {
                var _a;
                let cardImage = card.querySelector('img');
                if (cardImage) {
                    cardImage.style.height = `${Math.min(maxHeight, cardImage.offsetHeight)}px`;
                    card.classList.add('.oa-product-image-processed');
                    card.setAttribute('img-height', maxHeight.toFixed().toString());
                    let box = cardImage.closest('div');
                    if (box) {
                        let imageHeight = parseInt((_a = card.getAttribute('img-height')) !== null && _a !== void 0 ? _a : "0");
                        box.style.height = `${imageHeight}px`;
                    }
                }
            });
        }
        else {
            setTimeout(() => {
                // this will mean that if 1 image is broken the resizing never happens
                parseImages();
            }, 100);
        }
    };
    const parseMobileImages = () => {
        let cards = document.querySelectorAll('.oa-product-container'), imagesLoaded = true;
        if (cards.length === 0) {
            imagesLoaded = false;
        }
        cards.forEach((card) => {
            let cardImage = card.querySelector('img');
            if (!(cardImage === null || cardImage === void 0 ? void 0 : cardImage.complete) || !cardImage.complete)
                imagesLoaded = false;
        });
        if (imagesLoaded) {
            cards.forEach((card) => {
                let cardImage = card.querySelector('img');
                if (cardImage) {
                    let box = cardImage.closest('div');
                    if (box) {
                        // set width of container box to the rendered width of the image
                        // the container has margin 0 auto, so it centers inside the 150px container
                        box.style.width = `${cardImage.offsetWidth}px`;
                    }
                }
            });
        }
        else {
            setTimeout(() => {
                // this will mean that if 1 image is broken the resizing never happens
                parseMobileImages();
            }, 100);
        }
    };
    useEffect(() => {
        if (orientation === "horizontal" && isDesktop) {
            parseImages();
        }
        else {
            parseMobileImages();
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (orientation === "horizontal" && isDesktop) {
            if (["category", "detail", "shop"].includes((_c = (_b = (_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.route) !== null && _c !== void 0 ? _c : "")) {
                parseImages();
            }
        }
        else {
            if (["category", "detail", "shop"].includes((_f = (_e = (_d = flow.currentView) === null || _d === void 0 ? void 0 : _d.route) === null || _e === void 0 ? void 0 : _e.route) !== null && _f !== void 0 ? _f : "")) {
                parseMobileImages();
            }
        }
    }, [flow === null || flow === void 0 ? void 0 : flow.currentView]);
    const renderCards = useMemo(() => {
        return (_jsx(_Fragment, { children: props.data.map((item, i) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                let imageUrl = item.image.startsWith('https')
                    ? `${item.image}`
                    : `${ConfigHolder.apiBaseUrl}${item.image}`;
                if (!imageUrl.includes('photoMissing')) {
                    imageUrl = imageUrl.concat(orientation === "horizontal" && isDesktop ? '?w=300&fit=scale' : '?w=150&fit=scale');
                }
                return (_jsxs(Card, { onClick: handleClick, itemProp: item.id, ref: item.productId, sx: Object.assign(Object.assign({ 
                        // backgroundColor: theme.palette.background.default,
                        // boxShadow: "none",
                        "&:hover": {
                            boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
                        }, position: 'relative', height: '100%' }, (((_a = props.config) === null || _a === void 0 ? void 0 : _a.action) === "purchase" && {
                        "& > div[role=button]": {
                            cursor: "default"
                        }
                    })), ((orientation === "vertical" || !isDesktop) && {
                        display: 'flex',
                        alignItems: 'stretch'
                    })), className: "oa-product-container", children: [orientation === "horizontal" && isDesktop && ( // webshop widget
                        _jsxs(CardActionArea, { component: "div", onClick: handleClick, disableRipple: ((_b = props.config) === null || _b === void 0 ? void 0 : _b.action) === "purchase", disableTouchRipple: ((_c = props.config) === null || _c === void 0 ? void 0 : _c.action) === "purchase", itemProp: item.id, sx: {
                                position: 'initial',
                                paddingBottom: ((_d = props.config) === null || _d === void 0 ? void 0 : _d.action) === "purchase" ?
                                    item.variances && ((_e = item.variances) === null || _e === void 0 ? void 0 : _e.length) > 0
                                        ? '32px'
                                        : '100px'
                                    : 0
                            }, children: [_jsxs(Box, { sx: {
                                        position: 'relative',
                                    }, children: [smartResize && (_jsx(ImageBackground, { name: item.name, imageUrl: `${imageUrl}` })), !smartResize && (_jsx("img", { src: `${imageUrl}`, title: item.name, style: {
                                                width: '100%',
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)'
                                            } }))] }), _jsxs(CardContent, { sx: {
                                        minHeight: item.variances && ((_f = item.variances) === null || _f === void 0 ? void 0 : _f.length) > 0 && ((_g = props.config) === null || _g === void 0 ? void 0 : _g.action) === "purchase" ? '17em' : '4em',
                                        overflow: 'hidden',
                                        paddingBottom: 0
                                    }, children: [_jsx(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: { fontSize: '1rem' }, children: item.name }), item.subtitle && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary' }, children: item.subtitle }))] }), _jsx(CardActions, { sx: { paddingTop: 0 }, children: ((_h = props.config) === null || _h === void 0 ? void 0 : _h.action) && (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                                                m: 0,
                                                width: 'calc(100% - 16px)',
                                                position: 'absolute',
                                                bottom: '16px'
                                            }, children: [(((_j = props.config) === null || _j === void 0 ? void 0 : _j.action) === "purchase" || ((_k = props.config) === null || _k === void 0 ? void 0 : _k.action) === "requiredPurchase") && (_jsx(_Fragment, { children: _jsx(Purchase, { product: item, productId: item.id, required: ((_l = props.config) === null || _l === void 0 ? void 0 : _l.action) === "requiredPurchase", selectCallback: selectCallback }) })), ((_m = props.config) === null || _m === void 0 ? void 0 : _m.action) === "detail" && (_jsx(Detail, { config: {
                                                        item: item,
                                                        toCategory: props.config.toCategory,
                                                        toDetail: props.config.toDetail,
                                                    } }))] }) })) })] })), (orientation === "vertical" || (orientation === "horizontal" && !isDesktop)) && ( // booking widget
                        // <Box
                        // onClick={handleClick}
                        // disableRipple={props.config?.action === "purchase"}
                        // disableTouchRipple={props.config?.action === "purchase"}
                        // itemProp={item.id}
                        // >
                        _jsxs(_Fragment, { children: [_jsxs(Box, { sx: {
                                        display: 'flex',
                                        width: '150px',
                                        minWidth: '150px'
                                    }, children: [smartResize && (_jsx(ImageBackground, { noPositioning: true, name: item.name, imageUrl: `${imageUrl}` })), !smartResize && (_jsx("img", { src: `${imageUrl}`, alt: item.name, style: {
                                                width: 150,
                                                objectFit: "contain",
                                                objectPosition: 'top'
                                            } }))] }), _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', flex: 'auto' }, children: _jsxs(CardContent, { sx: {
                                            minHeight: item.variances && ((_o = item.variances) === null || _o === void 0 ? void 0 : _o.length) > 0 && ((_p = props.config) === null || _p === void 0 ? void 0 : _p.action) === "purchase" ? '11em' : '4em',
                                            overflow: 'hidden',
                                            paddingBottom: 0,
                                            flex: '1 0 auto'
                                        }, children: [_jsx(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: { fontSize: '1rem' }, children: item.name }), item.subtitle && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary' }, children: item.subtitle })), ((_q = props.config) === null || _q === void 0 ? void 0 : _q.action) && (_jsx(_Fragment, { children: (((_r = props.config) === null || _r === void 0 ? void 0 : _r.action) === "purchase" || ((_s = props.config) === null || _s === void 0 ? void 0 : _s.action) === "requiredPurchase") && (_jsx(_Fragment, { children: _jsx(Purchase, { product: item, productId: item.id, required: ((_t = props.config) === null || _t === void 0 ? void 0 : _t.action) === "requiredPurchase", selectCallback: selectCallback }) })) }))] }) })] })
                        // </Box>
                        // </CardActionArea>
                        )] }, `${i}_${item.id}`));
            }) }));
    }, [props.data]);
    return (_jsxs(Box, { sx: Object.assign(Object.assign({ minWidth: 120, maxWidth: '100%', marginX: 1 }, ((["select", "select1", "select2"].includes(currentRoute)) && {
            height: widgetMode === "standalone"
                ? (isDesktop
                    // 201px from BasicNav, + 56px for tabs
                    ? 'calc(100dvh - 257px)'
                    // 98px from BasicNav, + 40px for tabs
                    : 'calc(100dvh - 138px)')
                : 'calc(100dvh - 96px)',
            overflowY: 'scroll',
        })), { "&::-webkit-scrollbar": {
                width: '4px',
                height: '10px'
            }, "&::-webkit-scrollbar-thumb": {
                background: theme.palette.primary.main,
                borderRadius: '1px'
            }, "&::-webkit-scrollbar-track": {
                background: 'transparent'
            }, "&::-webkit-scrollbar-corner": {
                background: 'transparent'
            } }), children: [_jsx(Collapse, { in: addedProduct, children: _jsxs(Paper, { elevation: 4, sx: Object.assign(Object.assign({ padding: 2, margin: 1, marginY: 4, position: 'sticky', top: '16px' }, (["crossSelling", "shop"].includes((_b = (_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.route.route) !== null && _b !== void 0 ? _b : "") && {
                        position: 'fixed',
                        top: orientation === "horizontal"
                            ? "56px"
                            : isMobile ? "30px" : "90px",
                        marginX: 0,
                        width: orientation === "horizontal"
                            ? "calc(100% - 110px)"
                            // : hasGroupedShop ? '416px' : '446px',
                            : hasGroupedShop
                                ? widgetMode === "standalone" && isDesktop
                                    ? "418px"
                                    : 'calc(100% - 50px)'
                                : widgetMode === "standalone" && isDesktop
                                    ? "448px"
                                    : 'calc(100% - 50px)',
                    })), { zIndex: 1 }), children: [_jsx(Alert, { severity: "success", sx: {
                                marginBottom: 2
                            }, action: _jsx(IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: () => {
                                    setAddedProduct(false);
                                }, children: _jsx(CloseIcon, { fontSize: "inherit" }) }), children: ts("%name% is toegevoegd aan je winkelwagen", { name: addedProductName }) }), ((_c = flow.currentView) === null || _c === void 0 ? void 0 : _c.route.route) !== "crossSelling" && (_jsxs(Box, { sx: {
                                textAlign: "center"
                            }, children: [_jsx(Button, { variant: 'outlined', onClick: toShop, sx: Object.assign({ m: 1 }, isMobile && {
                                        width: '100%'
                                    }), children: t('Verder winkelen') }), _jsx(Button, { variant: 'contained', onClick: toNext, sx: Object.assign({ m: 1 }, isMobile && {
                                        width: '100%'
                                    }), children: t('Naar de winkelwagen') })] }))] }) }), _jsxs(Box, { sx: {
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: `repeat(${maxItems}, 1fr)`,
                    // gridTemplateColumns: `repeat(auto-fill, minmax(min(${widgetWidth / maxItems}px, 100%), ${optimalWidth}px))`,
                    gap: 2,
                }, children: [((_d = props.config) === null || _d === void 0 ? void 0 : _d.label) && (_jsx(Typography, { variant: "h5", sx: { color: theme.palette.text.primary, my: 1 }, children: t((_e = props.config) === null || _e === void 0 ? void 0 : _e.label) })), renderCards] })] }));
}
